export const CREATE_DOCUMENT_ACTION = 'documents/create-document';
export const GET_ALL_DOCUMENTS_ACTION = 'documents/get-all-documents';
export const GET_DOCUMENT_BY_ID_ACTION = 'documents/get-document-by-id';
export const PROCESS_DOCUMENT_ACTION = 'documents/process-document';